// extracted by mini-css-extract-plugin
export var indeterminate = "_3x-5";
export var md = "_3x-4";
export var semantic = "_3x-6";
export var sm = "_3x-3";
export var text = "_3x-7";
export var toggleInput = "_3x-0";
export var toggleSwitch = "_3x-1";
export var xs = "_3x-2";